import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
    const siteTitle = "Tonalida - Simplificando o Recrutamento e Seleção";
    const defaultDescription = "Sistema completo de recrutamento e seleção com inteligência artificial. Conectamos empresas e candidatos de forma ágil e eficiente.";
    const defaultImage = "/og-image-default.png"; // You should ensure this image exists in public folder
    const siteUrl = "https://tonalida.com.br"; // Replace with actual domain

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{title ? `${title} | Tonalida` : siteTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            {keywords && <meta name="keywords" content={Array.isArray(keywords) ? keywords.join(', ') : keywords} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url ? `${siteUrl}${url}` : siteUrl} />
            <meta property="og:title" content={title ? `${title} | Tonalida` : siteTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image || defaultImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url ? `${siteUrl}${url}` : siteUrl} />
            <meta name="twitter:title" content={title ? `${title} | Tonalida` : siteTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            <meta name="twitter:image" content={image || defaultImage} />
        </Helmet>
    );
};

export default SEO;
